import { getStats } from "@/services/apiCars";
import { useQuery } from '@tanstack/react-query';
import StatistisCard from './components/StatistisCard'; // Adjust this path as needed

export default function GeneralStatistics(){
  const { data, isLoading, error } = useQuery({
    queryKey: ['car-stats'],
    queryFn: getStats,
  });

  if (isLoading) return <p>Loading car statistics...</p>;
  if (error) return <p>Error loading statistics.</p>;

  const {
    totalCars,
    listedCarsWithServicioPago,
    listedCarsWithoutServicioPago,
    averageDaysPublishedListed,
    averageDaysArchivo,
    soldCars,
    carsByBusiness,
    listedCarsOlderThan30Days,
    archivoCarsWithFechaDeArchivoOlderThan30Days,
  } = data;

  const statsList = [
    { label: 'Total Cars', value: totalCars?.[0]?.count ?? 0 },
    { label: 'Listed (Servicio Pago)', value: listedCarsWithServicioPago?.[0]?.count ?? 0 },
    { label: 'Listed (No Servicio Pago)', value: listedCarsWithoutServicioPago?.[0]?.count ?? 0 },
    { label: 'Avg. Days Listed', value: Math.round(averageDaysPublishedListed?.[0]?.avgDaysPublished ?? 0) },
    { label: 'Avg. Days Since Archived', value: Math.round(averageDaysArchivo?.[0]?.avgDaysArchivo ?? 0) },
    { label: 'Sold Cars', value: soldCars?.[0]?.count ?? 0 },
    { label: 'Inversion Cars', value: carsByBusiness?.find((b:any) => b._id === 'inversion')?.count ?? 0 },
    { label: 'Promocion Cars', value: carsByBusiness?.find((b:any) => b._id === 'promocion')?.count ?? 0 },
    { label: 'Listed ≥ 30 Days', value: listedCarsOlderThan30Days?.[0]?.count ?? 0 },
    { label: 'Archivo ≥ 30 Days', value: archivoCarsWithFechaDeArchivoOlderThan30Days?.[0]?.count ?? 0 },
  ];

  return (<div className="flex flex-col">
    <h1 className="flex justify-center mb-6 text-4xl md:text-6xl font-bold text-[#001a50] md:text-end  leading-tight md:flex-1">Estadísticas Generales</h1>
    <StatistisCard items={statsList} />
  </div>);
};


